export enum SearchTableStateEnum {
  Loading = 'LOADING',
  Loaded = 'LOADED',
}